<template>
  <div class="_35lz77bA">
    <div class="_1SI39Ofv" v-if="show">
      <div class="_9-ZpLxb0">
        <img
          src="data:image/png;base64,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"
          alt="icon"
        />
        <div class="_3_qzGcRD"><span class="_1N8mCmac">-</span><span>B</span><span>O</span><span>B</span><span>.</span><span>C</span><span>O</span><span>M</span><span class="_1N8mCmac">-</span></div>
      </div>
    </div>
    <div class="_24vddGqv">
      <div class="wjHkeryU">
        <div class="_29gnuiyG animated fadeInUp" style="margin: 82px auto 71px">
          <div class="_35_vygsc">
            <h1 style="margin-top: -23px">电竞投注</h1>
            <h2>ESPORTS EVENTS</h2>
          </div>
          <!-- <div class="_2zJiZW9W">
            <div class="_349CzCYy xJQe3jRu _12ZkQT2g _3gi7jqcw" style="padding: 0px"><img class="_2JoosS9F" src="/static/image/ia.png" alt="" /><img class="_2JoosS9F hover" src="/static/image/ia-hover.png" alt="" /><span>小艾电竞</span></div>
            <div class="_349CzCYy xJQe3jRu _3gi7jqcw" style="padding: 0px"><img class="_2JoosS9F" src="/static/image/ld.png" alt="" /><img class="_2JoosS9F hover" src="/static/image/ld-hover.png" alt="" /><span>雷火电竞</span></div>
            <div class="_349CzCYy xJQe3jRu _3gi7jqcw" style="padding: 0px"><img class="_2JoosS9F" src="/static/image/12.png" alt="" /><img class="_2JoosS9F hover" src="/static/image/12-hover.png" alt="" /><span>泛亚电竞</span></div>
            <div class="_349CzCYy xJQe3jRu _3gi7jqcw" style="padding: 0px"><img class="_2JoosS9F" src="/static/image/ob.png" alt="" /><img class="_2JoosS9F hover" src="/static/image/ob-hover.png" alt="" /><span>OB电竞</span></div>
          </div> -->
          <div class="_2zJiZW9W">
            <div @click="changplatform_name(item.platform_name)" :class="platform_name == item.platform_name ? '_349CzCYy xJQe3jRu _3gi7jqcw _12ZkQT2g' : '_349CzCYy xJQe3jRu _3gi7jqcw'" v-for="(item, index) in gameList" :key="index" v-if="item.app_state == 1" style="padding: 0px">
              <img class="_2JoosS9F"  v-if="imgList[item.platform_name]" :src="imgList[item.platform_name]['img']" alt="" /><img class="_2JoosS9F hover"  v-if="imgList[item.platform_name]" :src="imgList[item.platform_name]['hover']" alt="" /><span>{{item.name}}</span>
            </div>
          </div>
        </div>
        <div class="h851vWpX" v-for="(item, index) in gameList" :key="index" v-if=" item.platform_name == platform_name">
          <div class="_1UE-ldYw"><img  v-if="imgList[item.platform_name]" :src="imgList[item.platform_name]['title']" class="oZtthmYX" /></div>
          <div class="_3bdNR9wu">
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>滚球标杆 自由串关</div>
                <div class="_1unX-k3M">独家大量滚球盘口，让您感受世界级滚球魅力</div>
              </div>
            </div>
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>秒确认 秒结算 妙体验</div>
                <div class="_1unX-k3M">注单秒确认，大型热门赛事秒结算电竞化UI风格，顶级交互设计，给您绝妙畅爽体验</div>
              </div>
            </div>
            <img class="B2lGJAHD" src="/static/image/pic7.png" style="height: 44px" />
            <div class="_2LINmtV0">
              <!-- plat_name=ia&game_type=2 -->
              <div v-if="item.app_state == 1" class="_349CzCYy xJQe3jRu _hPM8cbq" @click="goGamePage(item.platform_name, item.game_code == null ? 0 : item.game_code, '')" style="border-radius: 25vh"><span>立即游戏</span></div>
              <div v-else class="_349CzCYy xJQe3jRu _hPM8cbq" style="border-radius: 25vh"><span>维护中</span></div>
            
            </div>
          </div>
          <div class="_3efekQzm">
            <img class="_1daGKxbJ _2x8Pq0NA" src="/static/image/bg_bob_02-bda0.png" /><img class="_1daGKxbJ ls-is-cached" src="/static/image/bg_bob_01-596e.png" />
            <div class="_1gXTPMRQ"><img class="_2vyEl2F2 ls-is-cached" src="/static/image/esports_ej_img_bob-f2ac.png" /></div>
            <img class="_3g2fFXQz _3mdBM6t-" src="/static/image/pic12.png" /><img class="_1T-KBsyv _3mdBM6t-" src="/static/image/pic13.png" />
          </div>
        </div>
        <div class="h851vWpX" style="display: none">
          <div class="_1UE-ldYw"><img src="/static/image/img_ia_title.png" class="oZtthmYX" /></div>
          <div class="_3bdNR9wu">
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>滚球标杆 自由串关</div>
                <div class="_1unX-k3M">独家大量滚球盘口，让您感受世界级滚球魅力</div>
              </div>
            </div>
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>秒确认 秒结算 妙体验</div>
                <div class="_1unX-k3M">注单秒确认，大型热门赛事秒结算电竞化UI风格，顶级交互设计，给您绝妙畅爽体验</div>
              </div>
            </div>
            <img class="B2lGJAHD" src="/static/image/pic7.png" style="height: 44px" />
            <div class="_2LINmtV0">
              <!-- plat_name=ia&game_type=2 -->
              <div class="_349CzCYy xJQe3jRu _hPM8cbq" @click="goGamePage('ia', '2', '')" style="border-radius: 25vh"><span>立即游戏</span></div>
            </div>
          </div>
          <div class="_3efekQzm">
            <img class="_1daGKxbJ _2x8Pq0NA" src="/static/image/bg_bob_02-bda0.png" /><img class="_1daGKxbJ ls-is-cached" src="/static/image/bg_bob_01-596e.png" />
            <div class="_1gXTPMRQ"><img class="_2vyEl2F2 ls-is-cached" src="/static/image/esports_ej_img_bob-f2ac.png" /></div>
            <img class="_3g2fFXQz _3mdBM6t-" src="/static/image/pic12.png" /><img class="_1T-KBsyv _3mdBM6t-" src="/static/image/pic13.png" />
          </div>
        </div>
        <div class="h851vWpX" style="display: none">
          <div class="_1UE-ldYw"><img src="/static/image/img_ld_title-.png" class="oZtthmYX" /></div>
          <div class="_3bdNR9wu">
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>赛事全面 结算快捷</div>
                <div class="_1unX-k3M">每日提供上百场丰富的电竞赛事，结算快捷、玩法多元，盘内赛事直播让您分秒精彩</div>
              </div>
            </div>
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>专业数据 尽在掌握</div>
                <div class="_1unX-k3M">盘内赛事分析、数据统计、实时更新的战况记录，使您运筹帷幄之中决胜千里之外</div>
              </div>
            </div>
            <img class="B2lGJAHD" src="/static/image/img_eports_icons-4dc3.png" style="height: 44px" />
            <div class="_2LINmtV0">
              <!-- http://mb2.tg-demo.cc:86/member/game?plat_name=ld&game_type=2 -->
              <div class="_349CzCYy xJQe3jRu _hPM8cbq" @click="goGamePage('ld', '2', '')" style="border-radius: 25vh"><span>立即游戏</span></div>
            </div>
          </div>
          <div class="_3efekQzm">
            <img class="_1daGKxbJ _2x8Pq0NA" src="/static/image/bg_im_hover-f111.png" /><img class="_1daGKxbJ ls-is-cached lazyloaded" src="/static/image/bg_im-869a.png" data-src="/static/image/bg_im-869a.png" />
            <div class="_1gXTPMRQ" style="transform: perspective(3000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)"><img class="_2vyEl2F2 lazyloaded" src="/static/image/img_lol_player-adac.png" data-src="/static/image/img_lol_player-adac.png" /></div>
            <img class="_3g2fFXQz _3mdBM6t-" src="/static/image/pic8.png" /><img class="_1T-KBsyv _3mdBM6t-" src="/static/image/pic9.png" />
          </div>
        </div>
        <div class="h851vWpX" style="display: none">
          <div class="_1UE-ldYw"><img src="/static/image/img_avia_title.png" class="oZtthmYX" /></div>
          <div class="_3bdNR9wu">
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>顶尖平台 开拓创新</div>
                <div class="_1unX-k3M">20+款超人气游戏、S系列、Ti系列，全球顶尖赛事全覆盖，提供专业赔率数据，结算赛果实时快捷</div>
              </div>
            </div>
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>以客为尊 用心感受</div>
                <div class="_1unX-k3M">盘内提供英雄时时乐独特玩法，激情不间断，比赛之余小憩更精彩</div>
              </div>
            </div>
            <img class="B2lGJAHD" src="/static/image/img_eports_icons-4dc3.png" style="height: 44px" />
            <div class="_2LINmtV0">
              <div class="_349CzCYy xJQe3jRu _hPM8cbq" @click="goGamePage('avia', '2', '')" style="border-radius: 25vh"><span>立即游戏</span></div>
            </div>
          </div>
          <div class="_3efekQzm">
            <img class="_1daGKxbJ _2x8Pq0NA" src="/static/image/bg_avia_hover-58e3.png" /><img class="_1daGKxbJ ls-is-cached" src="/static/image/bg_avia-a4b8.png" />
            <div class="_1gXTPMRQ"><img class="_2vyEl2F2" src="/static/image/img_king_player-027c.png" /></div>
            <img class="_3g2fFXQz _3mdBM6t-" src="/static/image/pic10.png" /><img class="_1T-KBsyv _3mdBM6t-" src="/static/image/pic11.png" />
          </div>
        </div>
        <div class="h851vWpX" style="display: none">
          <div class="_1UE-ldYw"><img src="/static/image/img_obdj_title.png" class="oZtthmYX" /></div>
          <div class="_3bdNR9wu">
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>顶尖平台 开拓创新</div>
                <div class="_1unX-k3M">20+款超人气游戏、S系列、Ti系列，全球顶尖赛事全覆盖，提供专业赔率数据，结算赛果实时快捷</div>
              </div>
            </div>
            <div class="Kyf8M7_8">
              <div class="_1M4fs2nI"></div>
              <div>
                <div>以客为尊 用心感受</div>
                <div class="_1unX-k3M">盘内提供英雄时时乐独特玩法，激情不间断，比赛之余小憩更精彩</div>
              </div>
            </div>
            <img class="B2lGJAHD" src="/static/image/img_eports_icons-4dc3.png" style="height: 44px" />
            <div class="_2LINmtV0">
              <div class="_349CzCYy xJQe3jRu _hPM8cbq" @click="goGamePage('obgdj', '2', '')" style="border-radius: 25vh"><span>立即游戏</span></div>
            </div>
          </div>
          <div class="_3efekQzm">
            <img class="_1daGKxbJ _2x8Pq0NA" src="/static/image/bg_avia_hover-58e3.png" /><img class="_1daGKxbJ ls-is-cached" src="/static/image/bg_avia-a4b8.png" />
            <div class="_1gXTPMRQ"><img class="_2vyEl2F2 ls-is-cached" src="/static/image/esports_ej_img_bob-f2ac.png" /></div>

            <img class="_3g2fFXQz _3mdBM6t-" src="/static/image/pic10.png" /><img class="_1T-KBsyv _3mdBM6t-" src="/static/image/pic11.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'electronic',
  data() {
    return {
      jumpUrl: null,
      gameList: [],
      show: false,
      platform_name: '',
      imgList: {
        ia: { img: '/static/image/sbty.png', hover: '/static/image/sbty_hover.png', title: '/static/image/img_ia_title.png' },
        ld: { img: '/static/image/ld.png', hover: '/static/image/ld-hover.png', title: '/static/image/img_ld_title-.png' },
        avia: { img: '/static/image/12.png', hover: '/static/image/12-hover.png', title: '/static/image/img_avia_title.png' },
        obgdj: { img: '/static/image/ob.png', hover: '/static/image/ob-hover.png', title: '/static/image/img_obdj_title.png' },
      },
    };
  },
  created() {
    let that = this;
    that.getGameList();
  },
  methods: {
    changplatform_name(val) {
      this.platform_name = val;
    },
    getGameList() {
      let that = this;
      that.show = true;
      that.$apiFun.get('/api/game/list', { category: 'gaming' }).then(res => {
        if (res.code == 200) {
          that.gameList = res.data;
          that.show = false;
          let arr = that.gameList;
          for (let i in arr) {
            if (arr[i]['app_state'] == 1) {
              that.platform_name = arr[i]['platform_name'];
              return;
            }
          }
        }
      });
    },
    goGamePage(name, type, code) {
      let p = this.$parent;
      while (p) {
        if (typeof p.openGamePage === 'function') {
          p.openGamePage(name, type, code);
          return;
        }
        p = p.$parent;
      }
    },
    showTost(title) {
      $('body').append(`
            <div class='ant-message' style='top: 400px;'><span><div class='ant-message-notice'><div class='ant-message-notice-content'>
            <div class='ant-message-custom-content ant-message-info'><span role='img' aria-label='info-circle' class='anticon anticon-info-circle'>
            <svg viewBox='64 64 896 896' focusable='false' data-icon='info-circle' width='1em' height='1em' fill='currentColor' aria-hidden='true'>
            <path d='M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z'></path></svg></span><span>
            ${title}
            </span></div></div></div></span>
            </div>`);
      setTimeout('$(".ant-message").detach()', 2000);
    },
  },
  mounted() {
    //场馆切换
    $('._2zJiZW9W ._349CzCYy').click(function () {
      var index = $(this).index();
      $(this).addClass('_12ZkQT2g').siblings().removeClass('_12ZkQT2g');
      $('.h851vWpX').eq(index).show().siblings('.h851vWpX').hide();
    });
    // $('._3efekQzm').hover(
    //   function () {
    //     $(this).find('._3g2fFXQz,._1T-KBsyv').removeClass('_3mdBM6t-');
    //     $(this).find('._1daGKxbJ:not(.ls-is-cached)').removeClass('_2x8Pq0NA');
    //     $(this).find('._2vyEl2F2').css({ transform: 'scale3d(1.05, 1.05, 1.05)', transition: 'all 0.3s' });
    //   },
    //   function () {
    //     $(this).find('._3g2fFXQz,._1T-KBsyv').addClass('_3mdBM6t-');
    //     $(this).find('._1daGKxbJ:not(.ls-is-cached)').addClass('_2x8Pq0NA');
    //     $(this).find('._2vyEl2F2').css('transform', 'scale3d(1, 1, 1)');
    //   },
    // );
    //设置左边界以便内容居中
    autoMargin();
    $(window).resize(function () {
      autoMargin();
    });
    function autoMargin() {
      var Width = $(window).width();
      var Margin = (Width - 1920) / 2 + 'px';
      $('.h851vWpX').css('margin-left', Margin);
    }
  },
  updated() {
    let that = this;
  },
  watch: {
    // 新窗口打开页面，解决浏览器拦截问题
    jumpUrl() {
      if (this.jumpUrl) {
        window.open(this.jumpUrl, '_blank');
      }
      this.jumpUrl = null;
    },
  },
};
</script>
<style lang="scss" scoped>
.fangda {
  animation: _308UEapr 0.5s ease-out;
}
.hover {
  display: none;
}
._3gi7jqcw:hover ._2JoosS9F {
  display: none;
}
._3gi7jqcw:hover .hover {
  display: block;
}
._3gi7jqcw._12ZkQT2g ._2JoosS9F {
  display: none;
}
._3gi7jqcw._12ZkQT2g .hover {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/electronic.vue